import React, { useState, useEffect } from "react";
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    if (!isOpen === false) {
      setIsDropdownOpen(false);
    }
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992) {
        setIsDropdownOpen(false); // close dropdown on larger screen hover behavior
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <img src="/logo192.png" alt="DNA Laboratory Logo" className="logo-img" />
        </div>

        <div className="hamburger" onClick={toggleMenu}>
          <div></div>
          <div></div>
          <div></div>
        </div>

        <ul className={`navbar-links ${isOpen ? "active" : ""}`}>
          <li>
            <Link to="/" onClick={closeMenu} className={location.pathname === "/" ? "active" : ""}>Home</Link>
          </li>
          <li>
            <Link to="/about" onClick={closeMenu} className={location.pathname === "/about" ? "active" : ""}>About Us</Link>
          </li>

          <li className={`dropdown ${location.pathname.startsWith("/products") ? "active" : ""} ${isDropdownOpen ? "open" : ""}`}>
            <span className="dropdown-toggle" onClick={toggleDropdown}>Our Products</span>
            <ul
              className="dropdown-menu"
              style={{
                display: isDropdownOpen || window.innerWidth > 992 ? 'block' : 'none'
              }}
            >
              <li><Link to="/products/anabolics-steroid" onClick={closeMenu}>Anabolics Steroid</Link></li>
              <li><Link to="/products/sarms" onClick={closeMenu}>SARMs</Link></li>
            </ul>
          </li>

          <li>
            <Link to="/contact" onClick={closeMenu} className={location.pathname === "/contact" ? "active" : ""}>Contact Us</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
